/** @jsxImportSource @emotion/react */
import {css} from '@emotion/react';
import { Button, Card, Icon, Image, Label } from 'semantic-ui-react'
import PropTypes from 'prop-types';
import ProductCardContentExtra from '../../../Products/ItemsList/ProductCardContentExtra';
import MenuCardContentExtra from '../../../Menu/MenuCardContentExtra';
import { useWebPSupportCheck } from "react-use-webp-support-check";
import { isPast } from "date-fns";
import useUser from '../../../Shared/UserProvider/useUser'
import { isProviderAPos } from '../../../../services/Provider/Provider.service'

const squareImg = '/img/image.png'

const Item = ({ item, onDeleteItem, onDeactivateItem, onActivateItem, canDelete = true,}) => {
    const supportsWebP = useWebPSupportCheck();
    const { user, canExtendCategories } = useUser()

    const getItemImage = (item) => {
        if (!item.image) {
            return squareImg;
        }

        if (item.image.indexOf('images.ulty.fr') === -1) {
            return item.image;
        }

        const path = item.image.replace(/https?:\/\/images.ulty.fr\//, '');
        if (supportsWebP) {
            return `https://thumbnails.ulty.fr/200x200/webp/${path}`;
        }
        return `https://thumbnails.ulty.fr/200x200/png/${path}`;
    }

    const isDisabled = item.activatedAt === null
    const isActivated = item.activatedAt && isPast(new Date(item.activatedAt))

    return (
    <Card color={(isProviderAPos(user.provider) && item.providerId === user.provider.id) ? 'green' : 'blue'} css={css`
        padding: 0 !important;
        position: relative;
        `}>
            {isDisabled && (
                <div css={css`
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background: rgba(255,255,255,0.6);
                    z-index: 2;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                `}>
                    <Button
                      basic
                      color='teal'
                      icon
                      onClick={() => {
                          onActivateItem(item)
                      }}
                    >
                        <Icon name='linkify' color={'teal'} />
                        Activer
                    </Button>
                </div>
            )}
            <Card.Content css={isDisabled ? css`opacity: 0.5;` : undefined}>
                {(canDelete && !isDisabled) && (
                  <Label as='a' color='red' corner={'right'} onClick={() => {
                      onDeleteItem(item)
                  }}>
                      <Icon name={'delete'} css={css`cursor: pointer !important;`} />
                  </Label>
                )}

                {(canExtendCategories() && item.providerId !== user.provider.id && isActivated) && (
                  <Label as='a' color='blue' corner={'right'} onClick={() => {
                      onDeactivateItem(item)
                  }}>
                      <Icon title='Désactiver' name={'linkify'} css={css`cursor: pointer !important;`} />
                  </Label>
                )}

                <Image
                  css={css`
                    max-height: 80px;
                    height: 80px !important;
                    object-fit: contain;
                    width: auto;
                    max-width: 80px;
                    user-select: none;
                    -moz-user-select: none;
                    -webkit-user-drag: none;
                    -webkit-user-select: none;
                    -ms-user-select: none;
                `}
                  floated='right'
                  size='tiny'
                  alt={item.object.name}
                  loading="lazy"
                  src={getItemImage(item)}
                />
                <div css={css`
                position: absolute;
                top: 0;
                left: 0;
                height: 100%;
                width: 100%;
            `}/>

                <Card.Header css={css`font-size: 1em !important;`}>{item.object.name}</Card.Header>
            </Card.Content>

            <Card.Content
              extra
            >
                {item.type === 'PRODUCT' &&
                  <ProductCardContentExtra
                    item={item}
                    basePrice={item.basePrice}
                    inventory={item.inventory}
                    linkTo={`/products/${item.id}`}
                  />
                }

                {item.type === 'MENU' &&
                  <MenuCardContentExtra
                    basePrice={item.basePrice}
                    inventory={item.inventory}
                    linkTo={`/menus/${item.id}`}
                  />
                }
            </Card.Content>
    </Card>
    )
}

Item.propTypes = {
    item: PropTypes.object.isRequired,
    canDelete: PropTypes.bool.isRequired,
    onDeleteItem: PropTypes.func
}

export default Item;
